// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const apiBase = 'http://187.157.158.150:3001/';
const publicApi = 'http://187.157.158.150:3000/';
// const apiBase = 'http://localhost:3001/';
// const publicApi = 'http://localhost:3000/';
export const environment = {
  production: false,
  apiUrl: apiBase + 'api/',
  publicApi: publicApi,
  agendaLegislatura: apiBase + 'documentos/',
  imagenes: apiBase + 'imagenes/',
  imgNoticias: apiBase + 'imgNoticias/',
  docLeyes: apiBase + 'legislacion/leyes/',
  docCodigos: apiBase + 'legislacion/codigos/',
  docReglamentos: apiBase + 'legislacion/reglamentos/',
  docDictamenes: apiBase + 'legislacion/dictamenes/',
  gpIniciativas: apiBase + 'documentosGaceta/iniciativas/',
  gpDecretosAcuerdos: apiBase + 'documentosGaceta/decretosAcuerdos/',
  gpAcuerdos: apiBase + 'documentosGaceta/decretosAcuerdos/',
  gpDictamenes: apiBase + 'documentosGaceta/dictamenes/',
  gpSesiones: apiBase + 'documentosGaceta/sesiones/',
  gpDebates: apiBase + 'documentosGaceta/debates/',
  gpReconocimientos: apiBase + 'documentosGaceta/reconocimientos/',
  documentos: apiBase + 'documentos/',
  imgDiputados: apiBase + 'imagesDiputados/',
  imgPartidos: apiBase + 'imgPartidos/',
  imgVisitas: apiBase + 'imgVisitas/',
  imgAdministrativos: apiBase + 'imgAdministrativos/',
  google_api_key: 'AIzaSyDQYTEHWuxb_tYZGhuXTISlU_it7qk1GgM',
  channelId: 'UCgDj28qosiWZUiQZFPJ31HQ',
  channelIdNotiCongreso: 'PLz73rG6J7-hIXQQbc8zq-6zTfo8xVSiwX',
  channelIdNotiCongresoMaya: 'PLz73rG6J7-hJUJ9mEj5gkbT5lrR-Iz2SJ',
  channelIdSesionComisiones: 'PLz73rG6J7-hKM0Eh-N5ffB5pL2__EpJxd',
  channel_maxResults: 8,
  localStorage_token_name: 'token_name'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
